import React from 'react';
import { motion } from 'framer-motion';
import { Palette, Sparkles, Scissors, Droplet, Layers, Brush, Eye } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { Button } from './ui/Button';
import { useLanguage } from '../i18n/LanguageContext';
export function Services() {
  const {
    t
  } = useLanguage();
  const services = [{
    Icon: Palette,
    title: t.services.items[0].title,
    items: t.services.items[0].desc
  }, {
    Icon: Sparkles,
    title: t.services.items[1].title,
    items: t.services.items[1].desc
  }, {
    Icon: Scissors,
    title: t.services.items[2].title,
    items: t.services.items[2].desc
  }, {
    Icon: Droplet,
    title: t.services.items[3].title,
    items: t.services.items[3].desc
  }, {
    Icon: Layers,
    title: t.services.items[4].title,
    items: t.services.items[4].desc
  }, {
    Icon: Brush,
    title: t.services.items[5].title,
    items: t.services.items[5].desc
  }, {
    Icon: Eye,
    title: t.services.items[6].title,
    items: <>
          {t.services.items[6].desc.split('Riam LuxeLashes')[0]}
          <span className="font-allura text-2xl align-middle mx-1" data-id="element-249">
            Riam LuxeLashes
          </span>
        </>
  }];
  return <section id="servicios" className="pt-10 md:pt-14 pb-20 md:pb-28 bg-riam-jet" data-id="element-250">
      <div className="container mx-auto px-4 md:px-6" data-id="element-251">
        <SectionHeading title={t.services.title} data-id="element-252" />

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 mt-16 max-w-7xl mx-auto" data-id="element-253">
          {services.map((service, index) => {
          const {
            Icon
          } = service;
          return <motion.div key={index} initial={{
            opacity: 0,
            scale: 0.95
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="surface-elevated p-8 rounded-sm text-center group transition-transform duration-500 hover:-translate-y-1" data-id="element-254">
                <div className="mb-6 flex justify-center icon-glow group-hover:icon-glow-strong transition-all duration-300 group-hover:scale-110" data-id="element-255">
                  <Icon size={36} stroke="url(#riamGold)" data-id="element-256" />
                </div>
                <h3 className="gold-shine font-script font-semibold text-3xl mb-4" data-id="element-257">
                  {service.title}
                </h3>
                <p className="font-sans text-sm text-riam-gold-light/70 leading-relaxed" data-id="element-258">
                  {service.items}
                </p>
              </motion.div>;
        })}
        </div>

        <div className="mt-16 text-center" data-id="element-259">
          <Button href="https://beautybyriam.booksy.com" data-id="element-260">
            {t.services.cta}
          </Button>
        </div>
      </div>
    </section>;
}